import Schema from '@data-driven-forms/react-form-renderer/dist/cjs/schema';
import { DBFormSchema, fieldTextSection, fieldLoginInput } from '..';

export const getLoginFormSchema = (schema: DBFormSchema): Schema => ({
  title: 'login form',
  fields: [
    fieldLoginInput('username', schema?.username, {
      sizes: { xs: 12 },
      className: 'mb-3',
      icon: 'fa-light fa-user-nurse',
      validate: [
        {
          type: 'username'
        }
      ]
    }),
    fieldLoginInput('password', schema?.password, {
      type: 'password',
      sizes: { xs: 12 },
      icon: 'fa-light fa-key',
      autoComplete: 'new-password',
      validate: [
        {
          type: 'strong-password'
        }
      ]
    })
  ].filter(Boolean)
});

export const getResetPswdLoginFormSchema = (schema: DBFormSchema): Schema => ({
  title: 'login form',
  fields: [
    fieldLoginInput('username', schema?.username, {
      sizes: { xs: 12 },
      className: 'mb-3 reset-control-div',
      icon: 'fa-light fa-user-nurse',
      iconColor: '#032830',
      Placeholder: 'Username',
      validate: [
        {
          type: 'username'
        }
      ]
    }),
    fieldLoginInput('password', schema?.password, {
      type: 'password',
      className: 'reset-control-div',
      iconColor: '#032830',
      sizes: { xs: 12 },
      Placeholder: 'Password',
      icon: 'fa-light fa-key',
      autoComplete: 'new-password',
      validate: [
        {
          type: 'strong-password'
        }
      ]
    })
  ].filter(Boolean)
});

// -----===[test schema]===-----
export const loginFormSchema: DBFormSchema = {
  username: { label: 'username', required: true },
  password: { label: 'password', required: true }
};
